
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal/solo-trip",
      function () {
        return require("private-next-pages/personal/solo-trip/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal/solo-trip"])
      });
    }
  